import React, { useState, useEffect, Profiler } from 'react';
import { isMobile } from 'react-device-detect';
import { Formik } from 'formik';
import Snackbar from '../../../components/Snackbar';
import { connect } from 'react-redux';
import { phoneNumberValidation } from '../../../utils/validations';
import { updatePhoneNumberClient } from '../../../store/actions/UserAction';
import { auths, firestore } from '../../../configs/environments/firebase/firebaseApp';
import FormPhoneNumberClient from './FormPhoneNumberClient';

const UpdatePhoneNumberClient = props => {
    
const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber ? props.phoneNumber : '');

useEffect(() => {
    props.phoneNumber && setPhoneNumber(props.phoneNumber);
}, [props.phoneNumber]);

const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'info'
});

const handleUpdatePhoneNumber = 
async ({ phoneNumber }, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
    const { uid, updatePhoneNumberClient } = props;
    
    try {
        await updatePhoneNumberClient(
            uid === undefined ? props.authClient.user.uid : uid,
            phoneNumber
        )
        setFeedbackMessage({
            open: true,
            message: 'Teléfono actualizado con éxito',
            variant: 'success'
        });
    } catch (error) {
        console.log(error);
        setFeedbackMessage({
            open: true,
            message: 'Ocurrio un error, no se logro actualizar el teléfono',
            variant: 'error'
        });
        setFieldError('phoneNumber', 'Vuelve a intentar más tarde');
    }
};

const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
        open: false,
        message: '',
        variant: 'info'
    });
};

return (
    <>
        <Formik
            initialValues={{ phoneNumber }}
            validationSchema={phoneNumberValidation}
            onSubmit={handleUpdatePhoneNumber}
            render={props => <FormPhoneNumberClient {...props} />}
        />
        
        <Snackbar
            open={feedbackMessage.open}
            variant={feedbackMessage.variant}
            message={feedbackMessage.message}
            handleClose={handleCloseFeedbackMessage}
            vertical="top"
            horizontal="right"
            snackbarTop={isMobile ? '8px' : '80px'}
        />
    </>
);
};

const mapDispatchToProps = dispatch => ({
    updatePhoneNumberClient:
        (uid, phone) => dispatch(updatePhoneNumberClient(uid, phone))
})

const mapStateToProps = state => ({
    phoneNumber: state.authClient.phone,
    uid: state.authClient.uid,
    authClient: state.authClient,
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePhoneNumberClient);
  